// 🔥 FireStarter - Main App Component

import { useState, useEffect } from 'react';
import LandingPage from './components/LandingPage';
import { Dashboard } from './components/Dashboard';
import { SystemTest } from './components/SystemTest';
import { DeveloperHub } from './components/DeveloperHub';
import { FileMap } from './components/FileMap';
import { LinksInventory } from './components/LinksInventory';
import { SecurityAudit } from './components/SecurityAudit';
import WorkDashboard from './components/WorkDashboard';
import ResearchDashboard from './components/ResearchDashboard';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import QuickLog from './components/QuickLog';
import SessionState from './components/SessionState';
import BuilderFocus from './components/BuilderFocus';
import CourseOfStudy from './components/CourseOfStudy';

function App() {
  // Enhanced hash-based routing with nested paths (no dependencies needed)
  const [currentPage, setCurrentPage] = useState('home');
  const [subPage, setSubPage] = useState<string | null>(null);
  const [pageId, setPageId] = useState<string | null>(null);

  useEffect(() => {
    // Read hash on mount and on hash change
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      // Parse nested routes like "log/recent" or "log/edit/123"
      const parts = hash.split('/');
      setCurrentPage(parts[0] || 'home');
      setSubPage(parts[1] || null);
      setPageId(parts[2] || null);
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Render the appropriate page
  switch (currentPage) {
    case 'focus':
      return <BuilderFocus />;
    case 'course':
      return <CourseOfStudy />;
    case 'work':
      return <WorkDashboard />;
    case 'research':
      return <ResearchDashboard />;
    case 'log':
      return <QuickLog subPage={subPage} pageId={pageId} />;
    case 'sessions':
      return <SessionState />;
    case 'terms':
      return <TermsOfService />;
    case 'privacy':
      return <PrivacyPolicy />;
    case 'dashboard':
      return <Dashboard />;
    case 'test':
      return <SystemTest />;
    case 'dev':
      return <DeveloperHub />;
    case 'files':
      return <FileMap />;
    case 'links':
      return <LinksInventory />;
    case 'security':
      return <SecurityAudit />;
    case 'home':
    default:
      return <LandingPage />;
  }
}

export default App;
